import createReactComponent from '../createReactComponent';
export default createReactComponent('pennant', 'IconPennant', [
  ['path', { d: 'M8 21l4 0', key: 'svg-0' }],
  ['path', { d: 'M10 21l0 -18', key: 'svg-1' }],
  ['path', { d: 'M10 4l9 4l-9 4', key: 'svg-2' }],
]);
